module.exports = __webpack_public_path__ + "img/icon-recibo.3be09d3f.svg";